import mobileLogo from '../../../assets/Name - White Transparent.svg'
import * as S from './styles'

export function MobileUnauthenticatedNav() {
  return (
    <S.MobileWrapper>
      <S.MobileNavLeft>
        <S.LogoImg
          className="pl-4"
          width="81px"
          src={mobileLogo}
          alt="mobileLogo"
        />
      </S.MobileNavLeft>
    </S.MobileWrapper>
  )
}
